var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "normal-page" },
        [
          _c("formBox", {
            attrs: { type: "month", total: _vm.total },
            on: { confirmData: _vm.confirmData },
          }),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "mt10",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, height: _vm.tableHeight },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "card.name", label: "姓名" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "frame.name", label: "部门" },
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "出勤统计" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "group", label: "考勤组名称", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.group || "--") +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "required_days",
                      label: "应出勤天数",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "actual_days",
                      label: "实际出勤天数",
                      width: "120",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "异常统计" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "late", label: "迟到次数", width: "120" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "leave_early",
                      label: "早退次数",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "late_card",
                      label: "上班缺卡",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "early_card",
                      label: "下班缺卡",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "absenteeism",
                      label: "旷工天数",
                      width: "120",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "trip_hours",
                  label: "出差（小时）",
                  width: "130",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "out_hours",
                  label: "外出（小时）",
                  width: "130",
                },
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "请假" } },
                _vm._l(_vm.holiday_type, function (item, index) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "holiday_data",
                          label:
                            item.name +
                            (item.duration_type === 0 ? " (天)" : " (小时)"),
                          width: "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        scope.row.holiday_data[index].duration
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-fixed" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-size": _vm.where.limit,
                  "current-page": _vm.where.page,
                  "page-sizes": [15, 20, 30],
                  layout: "total,sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("export-excel", {
        ref: "exportExcel",
        attrs: { "save-name": _vm.saveName, "export-data": _vm.exportData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }